import apiFetch from '../apiFetch'

export default function (dossierId, token, lastAccessDate) {
  return apiFetch({ endPoint: `Dossier/${dossierId}/UndoCancel`, method: 'PUT', body: null, token: token, lastAccessDate })
}
